export const calculateProductPriceIncrease = (productPrice: number | string): number =>
	parseFloat(productPrice.toString()) * 1.15;
